import React, { useEffect, useRef, useState } from "react";

const SidebarContentLayout = ({ contentData }) => {
    const [activeItem, setActiveItem] = useState(null);

    // Create refs for each section
    const sectionRefs = useRef({});

    // Initialize refs for each section
    useEffect(() => {
        sectionRefs.current = {};
        contentData.sections.forEach(section => {
            sectionRefs.current[section.id] = React.createRef();
        });
    }, [contentData.sections]);

    useEffect(() => {
        const handleScroll = () => {
            // Find all section elements
            const sections = contentData.sections.map(section => ({
                id: section.id,
                element: document.getElementById(section.id)
            })).filter(section => section.element);

            // Check which section is currently in view
            let currentSection = null;
            let closestDistance = Infinity;

            sections.forEach(section => {
                if (section.element) {
                    const rect = section.element.getBoundingClientRect();
                    const distanceFromTop = Math.abs(rect.top);

                    // Find the section closest to the top of the viewport
                    if (distanceFromTop < closestDistance) {
                        closestDistance = distanceFromTop;
                        currentSection = section.id;
                    }
                }
            });

            if (currentSection && currentSection !== activeItem) {
                setActiveItem(currentSection);
            }
        };

        // Add event listener for scroll
        window.addEventListener("scroll", handleScroll);
        
        // Initial check for active section
        setTimeout(handleScroll, 100);

        // Remove event listener on component unmount
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [contentData.sections]); // Remove activeItem dependency to prevent re-registering the event

    // Scroll to the target element when called
    const scrollToSection = (id) => {
        const element = document.getElementById(id);
        if (element) {
            const yOffset = -80; // Adjust this value based on your header height
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            
            window.scrollTo({
                top: y,
                behavior: 'smooth'
            });
            
            setActiveItem(id);
        }
    };

    const sidebarItems = contentData.sections.map(section => ({
        id: section.id,
        title: section.title
    }));

    return (
        <div className="col-md-12 d-flex flex-row flex-wrap d-inline-block align-items-start mt-4">
            <div className="col-md-8 d-inline-block pull-left">
                <h1>{contentData.title}</h1>
                {contentData.effectiveDate && (
                    <p className="c13">
                        <span className="c6">Effective Date:</span>
                        <span className="c2">&nbsp;{contentData.effectiveDate}</span>
                    </p>
                )}

                {contentData.sections.map((section) => (
                    <div key={section.id} className="mb-4">
                        <h3 
                            id={section.id}
                            ref={sectionRefs.current[section.id]} 
                            className="c0 my-3 fw-bold fs-4"
                        >
                            {section.title}
                        </h3>
                        {section.content.map((contentItem, index) => (
                            <div key={index} dangerouslySetInnerHTML={{ __html: contentItem }} />
                        ))}
                    </div>
                ))}
            </div>
            <div
                style={{
                    position: "sticky",
                    top: "50px",
                }}
                className="col-md-4 p-3 h-100"
            >
                <ul
                    style={{
                        listStyle: "none",
                        borderLeft: "2px solid #ccc",
                    }}
                    className="col-md-12 p-3"
                >
                    {sidebarItems?.map((item, index) => (
                        <li
                            key={index}
                            className={`col-md-12 p-0 my-2 ${item.id === activeItem ? "fw-bold" : ""}`}
                            style={{
                                cursor: "pointer",
                            }}
                        >
                            <p onClick={() => scrollToSection(item.id)}>{item?.title}</p>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default SidebarContentLayout;